import React, { useState } from "react";


import {
  FaBus,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

const RESPONSIVE_CSS = `
  .thp-hero-inner {
    width: 92% !important;
    padding: 38px 0px !important;
  }
  .thp-hero-icon {
    width: 44px !important;
    height: 44px !important;
  }
  .thp-hero-title {
    font-size: clamp(22px, 5vw, 34px) !important;
  }
  .thp-hero-desc {
    font-size: clamp(13px, 2vw, 15px) !important;
    line-height: 1.8 !important;
  }
  .thp-accordion-wrap {
    width: 92% !important;
    padding: 28px 0px 50px !important;
  }
  .thp-accordion-header {
    padding: 14px 16px !important;
    gap: 10px !important;
  }
  .thp-accordion-title {
    font-size: 15px !important;
  }
  .thp-accordion-content {
    padding: 16px 18px !important;
  }
  .thp-point-text {
    font-size: 14px !important;
  }

  @media (max-width: 600px) {
    .thp-hero-inner {
      width: 90% !important;
      padding: 28px 0px !important;
    }
    .thp-hero-row {
      gap: 10px !important;
      margin-bottom: 12px !important;
    }
    .thp-hero-icon {
      width: 38px !important;
      height: 38px !important;
      border-radius: 8px !important;
    }
    .thp-hero-icon svg {
      font-size: 17px !important;
    }
    .thp-hero-title {
      font-size: clamp(19px, 6vw, 26px) !important;
    }
    .thp-hero-desc {
      font-size: 13px !important;
      line-height: 1.7 !important;
    }
    .thp-accordion-wrap {
      width: 92% !important;
      padding: 20px 0px 36px !important;
    }
    .thp-accordion-header {
      padding: 12px 14px !important;
    }
    .thp-accordion-title {
      font-size: 14px !important;
      line-height: 1.4 !important;
    }
    .thp-accordion-content {
      padding: 14px 14px !important;
    }
    .thp-point-row {
      gap: 10px !important;
      margin-bottom: 10px !important;
    }
    .thp-point-check {
      width: 20px !important;
      height: 20px !important;
      min-width: 20px !important;
    }
    .thp-point-check svg {
      font-size: 9px !important;
    }
    .thp-point-text {
      font-size: 13px !important;
      line-height: 1.6 !important;
    }
  }

  @media (max-width: 360px) {
    .thp-hero-title {
      font-size: 18px !important;
    }
    .thp-accordion-title {
      font-size: 13px !important;
    }
  }
`;

function TourismHospitalityPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Customer Experience & Travel Planning",
      points: [
        "Personalized Travel Itinerary Agent",
        "Smart Booking Assistant Agent",
        "Real-Time Flight/Train Update Agent",
        "Language Translation Companion Agent",
        "Local Experience Recommendation Agent",
      ],
    },

    {
      title: "Hotel Operations",
      points: [
        "Smart Room Allocation Agent",
        "Front Desk Virtual Concierge",
        "Guest Feedback Sentiment Analyzer",
        "Room Service Automation Agent",
        "Housekeeping Schedule Optimizer",
      ],
    },

    {
      title: "Marketing & Sales",
      points: [
        "Seasonal Campaign Personalization Agent",
        "Social Media Engagement Agent",
        "Ad Spend Optimizer Agent",
        "Visitor Review Monitoring Agent",
        "Influencer Recommendation Agent",
      ],
    },

    {
      title: "Financials & Strategy",
      points: [
        "Revenue Forecasting Agent",
        "Overbooking Prediction Agent",
        "Cancellation Pattern Detection Agent",
        "Corporate Package Customization Agent",
        "Operational Efficiency Agent",
      ],
    },

    {
      title: "Safety & Compliance",
      points: [
        "Traveler Document Verification Agent",
        "Real-time Emergency Alert Agent",
        "Pandemic Protocol Compliance Bot",
        "Security Incident Prediction Agent",
        "Travel Insurance Assistant Agent",
      ],
    },
  ];

  return (
    <>
      <style>{RESPONSIVE_CSS}</style>

      <div
        style={{
          background: "#22c7b8",
          minHeight: "100vh",
          overflowX: "hidden",
        }}
      >
        {/* HERO SECTION */}
        <div
          style={{
            background: "#173b8f",
            width: "100%",
          }}
        >
          <div
            className="thp-hero-inner"
            style={{
              width: "92%",
              maxWidth: "1300px",
              margin: "0 auto",
              padding: "38px 0px",
              boxSizing: "border-box",
            }}
          >
            <div
              className="thp-hero-row"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "16px",
                flexWrap: "wrap",
              }}
            >
              <div
                className="thp-hero-icon"
                style={{
                  width: "44px",
                  height: "44px",
                  background: "#22c7b8",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <FaBus
                  style={{
                    color: "#ffffff",
                    fontSize: "20px",
                  }}
                />
              </div>

              <h1
                className="thp-hero-title"
                style={{
                  color: "#ffffff",
                  fontSize: "34px",
                  fontWeight: "700",
                  margin: 0,
                  fontFamily: "Exo, sans-serif",
                  wordBreak: "break-word",
                }}
              >
                Tourism & Hospitality
              </h1>
            </div>

            <p
              className="thp-hero-desc"
              style={{
                color: "#f2f2f2",
                fontSize: "15px",
                lineHeight: "1.9",
                maxWidth: "1000px",
                margin: 0,
              }}
            >
              Encompasses travel, accommodation, and guest services. AI agents assist in itinerary planning, multilingual guest support, smart room management, review analysis, and AR/VR experiences.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div
          className="thp-accordion-wrap"
          style={{
            width: "78%",
            maxWidth: "1050px",
            margin: "0 auto",
            padding: "28px 0px 50px",
            boxSizing: "border-box",
          }}
        >
          {sections.map((section, index) => (
            <div
              key={index}
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                marginBottom: "10px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              }}
            >
              {/* HEADER */}
              <div
                onClick={() => toggle(index)}
                className="thp-accordion-header"
                style={{
                  padding: "14px 18px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  background:
                    openIndex === index
                      ? "#173b8f"
                      : "#ffffff",
                  transition: "0.3s",
                  gap: "12px",
                  boxSizing: "border-box",
                }}
              >
                <h2
                  className="thp-accordion-title"
                  style={{
                    margin: 0,
                    fontSize: "16px",
                    fontWeight: "700",
                    color:
                      openIndex === index
                        ? "#ffffff"
                        : "#173b8f",
                    fontFamily: "Exo, sans-serif",
                    wordBreak: "break-word",
                    minWidth: 0,
                  }}
                >
                  {section.title}
                </h2>

                {openIndex === index ? (
                  <FaChevronUp
                    style={{
                      color: "#ffffff",
                      fontSize: "16px",
                      flexShrink: 0,
                    }}
                  />
                ) : (
                  <FaChevronDown
                    style={{
                      color: "#173b8f",
                      fontSize: "16px",
                      flexShrink: 0,
                    }}
                  />
                )}
              </div>

              {/* CONTENT */}
              {openIndex === index && (
                <div
                  className="thp-accordion-content"
                  style={{
                    padding: "18px 24px",
                    background: "#ffffff",
                    boxSizing: "border-box",
                  }}
                >
                  {section.points.map((point, i) => (
                    <div
                      key={i}
                      className="thp-point-row"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        marginBottom: "12px",
                      }}
                    >
                      <div
                        className="thp-point-check"
                        style={{
                          width: "24px",
                          height: "24px",
                          minWidth: "24px",
                          borderRadius: "50%",
                          background: "#22c7b8",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaCheck
                          style={{
                            color: "#ffffff",
                            fontSize: "10px",
                          }}
                        />
                      </div>

                      <p
                        className="thp-point-text"
                        style={{
                          margin: 0,
                          color: "#4b5563",
                          fontSize: "15px",
                          lineHeight: "1.7",
                          fontWeight: "500",
                          wordBreak: "break-word",
                        }}
                      >
                        {point}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default TourismHospitalityPage;
